var render = function render(_c,_vm){return _c('div',{class:{
	container: !_vm.fluid,
	'container-fluid': _vm.fluid,
	..._vm.$options.classes(_vm.props, _vm.data)
	}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }